import { render, staticRenderFns } from "./NavbarDropdownItem.vue?vue&type=template&id=9048a9a8&scoped=true&"
import script from "./NavbarDropdownItem.vue?vue&type=script&lang=js&"
export * from "./NavbarDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./NavbarDropdownItem.vue?vue&type=style&index=0&id=9048a9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9048a9a8",
  null
  
)

export default component.exports